import { render, staticRenderFns } from "./EditActivoPage.vue?vue&type=template&id=34ca02c6"
import script from "./EditActivoPage.vue?vue&type=script&lang=js"
export * from "./EditActivoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports